export default function imageList({ variables, }) {
    return {
        MuiImageList: {
            styleOverrides: {
                root: {
                    borderRadius: variables.border_radius_medium,
                },
            },
        },
        MuiImageListItemBar: {
            styleOverrides: {
                root: {
                    backgroundColor: variables.popper_background,
                },
                title: {
                    fontSize: variables.type_body_sm_font_size,
                    fontWeight: variables.font_weight_medium,
                },
                subtitle: {
                    fontSize: variables.type_caption_font_size,
                },
            },
        },
    };
}
//# sourceMappingURL=imageList.js.map